import React, {useState, useEffect} from "react";
import { useTranslation } from "react-i18next";
import Dropdown from "react-bootstrap/Dropdown";
import { useSelector } from "react-redux";
import { getWithExpiry } from '../../common';
import { Link } from "react-router-dom";
import svIcon from '../../images/flags/sv.png';
import enIcon from '../../images/flags/en.png';
import { useCookies } from "react-cookie";

const HorizontalNav = (props) => {
  const [translation] = useTranslation("translations");
  const userData = useSelector((state) => state?.userdata?.allUserData);

  const [profilePic, setProfilePic] = useState('');
  const [cookies] = useCookies(["sc_user_lang"]);
  const [userLang, setUserLang] = useState('sv');

  useEffect(() => {

    const savedProfilePic = getWithExpiry('profile_img_url');

    if ( savedProfilePic ) {
        setProfilePic( savedProfilePic );
    } else {
        if ( userData?.user_avatar) {
            setProfilePic(userData?.user_avatar);
        }
    }

    if ( cookies.sc_user_lang ) {
      setUserLang( cookies.sc_user_lang );
    }

}, [userData, cookies.sc_user_lang]);

  return (
    <div className="horizontal-main-nav-wrap d-none d-lg-block position-fixed top-0 bg-white border-bottom shadow-sm">
      <div className="ps-4 pe-3 d-flex align-items-center h-100">
        <div className="flex-grow-1">
          <h3 className="ps-5" dangerouslySetInnerHTML={{__html: props.title}}></h3>
        </div>
        <div className="d-flex align-items-center">
          {userData && userData.membership_slugs && (
            <Dropdown>
              <Dropdown.Toggle variant="" id="profile-dropdown">
                <span className="pe-2">
                  {translation("welcome")} {userData?.first_name}
                </span>
                <div className="profile-nav-warp bg-primary rounded-circle d-flex justify-content-center align-items-center">

                  { profilePic &&
                    <img src={profilePic} alt="Profile" className="mw-100 w-100 rounded-circle" />
                  }

                  {!profilePic && userData?.first_name && (
                    <span className="text-white text-uppercase fw-bold h5 mb-0">
                      {userData?.first_name?.charAt(0)}
                    </span>
                  )}
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="/settings/">
                  {translation("settings")}
                </Dropdown.Item>

                {Object.values(userData?.roles).includes("administrator") &&
                  <>
                    <Dropdown.Divider />
                    <Dropdown.Item href="/organizations">Organisationer</Dropdown.Item>
                  </>
                }

                { (userData?.organization !== 0 && userData?.organization !== '' ) && userData?.org_name && userData?.org_name?.length > 0 &&
                  <>
                    <Dropdown.Divider />
                    <Dropdown.Item href={`/organizations/${userData?.organization}`}>{userData?.org_name}</Dropdown.Item>
                  </>
                }


                <Dropdown.Divider />
                <Dropdown.Item href="/login/?logout=true">
                  {translation("log_out")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}

          <Dropdown>
            <Dropdown.Toggle variant="" id="language-switch">
              <div className="d-flex ps-2 align-items-center">
                <span className="pe-2 text-uppercase">
                  {userLang}
                </span>
                <div className="rounded-circle d-flex justify-content-center align-items-center">
                  <img src={userLang === 'en' ? enIcon : svIcon} alt="Svenska" className="rounded-circle" style={{width:'30px',height: '30px'}} />
                </div>
              </div>
            </Dropdown.Toggle>
            
            <Dropdown.Menu>
              <Dropdown.Item href={`${window.location.pathname}?lang=sv`}>
                <div className="d-flex ps-2 align-items-center">
                  <div className="rounded-circle d-flex justify-content-center align-items-center">
                    <img src={svIcon} alt="Svenska" className="rounded-circle" style={{width:'30px',height: '30px'}} />
                  </div>
                  <span className="ps-2">
                    Svenska
                  </span>
                </div>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item href={`${window.location.pathname}?lang=en`}>
                <div className="d-flex ps-2 align-items-center">
                  <div className="rounded-circle d-flex justify-content-center align-items-center">
                    <img src={enIcon} alt="Svenska" className="rounded-circle" style={{width:'30px',height: '30px'}} />
                  </div>
                  <span className="ps-2">
                    English
                  </span>
                </div>
              </Dropdown.Item>
            </Dropdown.Menu>

          </Dropdown>

          { !userData &&
            <Link to="/login/?logout=true" className="btn btn-link text-black" >{translation("log_out")}</Link>
          }
        </div>
      </div>
    </div>
  );
};

export default HorizontalNav;
